'use client' // Error components must be Client components

const SessionIndicatorError = () => null
export default SessionIndicatorError
